function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockCheckmarkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    d: "M22.999,25.999C19.89,25.999 17.332,23.441 17.332,20.332C17.332,17.223 19.89,14.665 22.999,14.665C26.108,14.665 28.666,17.223 28.666,20.332C28.663,23.44 26.107,25.996 22.999,25.999ZM22.406,23.38L19.629,21.787L20.218,20.762L22.076,21.833L25.289,17.377L26.241,18.065L22.406,23.38Z",
    style: {
      fill: "rgb(117,117,117)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11567",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(117,117,117)",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13909",
    transform: "matrix(1,0,0,1,3.333,4.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    d: "M11.332,22.665C5.124,22.658 0.019,17.547 0.019,11.339C0.019,5.126 5.132,0.013 11.345,0.013C16.71,0.013 21.375,3.825 22.444,9.083C22.017,8.932 21.576,8.821 21.128,8.752C20.011,4.53 16.287,1.483 11.928,1.222L11.928,3.577L10.736,3.577L10.736,1.222C5.639,1.528 1.529,5.639 1.224,10.736L3.58,10.736L3.58,11.929L1.224,11.929C1.53,17.026 5.64,21.136 10.736,21.443L10.736,19.088L11.929,19.088L11.929,21.443C12.829,21.391 13.717,21.218 14.571,20.93C14.876,21.265 15.21,21.571 15.571,21.844C14.224,22.389 12.785,22.668 11.332,22.665ZM11.932,11.929L7.159,11.929L7.159,10.736L10.739,10.736L10.739,5.369L11.932,5.369L11.932,11.929Z",
    style: {
      fill: "rgb(117,117,117)",
      fillRule: "nonzero",
      stroke: "black",
      strokeOpacity: 0,
      strokeWidth: 1
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockCheckmarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Clock_Checkmark_icon.34d04850a618411ad090c7f3771793d4.svg";